import React from 'react';
import { Box, Divider, Skeleton } from '@mui/material';

const containerStyles = {
  display: 'grid',
  gridGap: 1,
  gridTemplateColumns: '100%',
  height: 80,
  p: 2,
};

const titleStyles = {
  borderRadius: 1,
  height: 25,
  width: '100%',
};

const countStyles = {
  borderRadius: 2,
  mr: 1,
  width: 25,
};

const textStyles = {
  borderRadius: 1,
  height: 18,
  width: '75%',
};

const TrailerSkeleton = () => {
  return (
    <>
      <Box sx={containerStyles}>
        <Skeleton sx={titleStyles} variant="rectangular" />
        <Box alignItems="center" display="flex">
          <Skeleton sx={countStyles} variant="rectangular" />
          <Skeleton sx={textStyles} variant="rectangular" />
        </Box>
      </Box>
      <Divider />
    </>
  );
};

export default TrailerSkeleton;
